<script>
import BreadcrumbsList from '@/components/breadcrumbsList';
import Md from '../md';
import ContentsContainer from './contentsContainer';
import ShareButtons from './shareButtons';
import Categories from './categories';
export default {
  components: {
    BreadcrumbsList,
    Md,
    ContentsContainer,
    ShareButtons,
    Categories
  },
  computed: {
    getKeyVisualURL() {
      const { formats, url } = this.article.keyVisual || {}
      const path = formats && formats.large ? formats.large.url : url
      return path ? this.$options.filters.cmsURL(path) : this.thumbnailURL;
    },
    thumbnailURL() {
      let path = null
      if (this.article.thumbnail) {
        path = this.article.thumbnail.formats.large ? this.article.thumbnail.formats.large.url : this.article.thumbnail.url
      }
      return path ? this.$options.filters.cmsURL(path) : null;
    }
  }
}
</script>
